// extracted by mini-css-extract-plugin
module.exports = {"picture":"styles_picture__c836d","image":"styles_image__0f226"};